(function () {
  'use strict';
  if (window.RPCartQuantityControls) return;
  window.RPCartQuantityControls = true;
  var busy = false;
  var mutationSelector = '[data-rp-step], [data-rp-remove], [data-action="update-item-quantity"], [data-action="remove-item"], [data-sample-qty], [data-sample-remove], [data-cart-clear-all], [data-cart-clear-confirm], [name="checkout"], a[href*="/checkout"]';

  function message(root, name) {
    var live = root.querySelector('[data-rp-global-status]');
    return live ? live.getAttribute('data-' + name) : '';
  }

  function rowFor(root, key) {
    return Array.from(root.querySelectorAll('[data-rp-line]')).find(function (row) {
      return row.getAttribute('data-rp-line') === key;
    });
  }

  function announce(root, row, text, error) {
    var node = row && row.querySelector('[data-rp-status]');
    node = node || root.querySelector('[data-rp-global-status]');
    if (!node) return;
    node.classList.toggle('RpQuantity__Status--error', !!error);
    node.setAttribute('role', error ? 'alert' : 'status');
    node.textContent = text;
  }

  async function update(root, row, quantity, trigger) {
    var input = row.querySelector('[data-rp-quantity]');
    var confirmed = Number(row.getAttribute('data-rp-confirmed'));
    var removing = trigger.hasAttribute('data-rp-remove');
    var key = row.getAttribute('data-rp-line');
    var wasInput = trigger === input;
    var step = trigger.getAttribute('data-rp-step');
    if (!Number.isSafeInteger(quantity) || quantity < (removing ? 0 : 1)) {
      input.value = confirmed;
      input.setAttribute('aria-invalid', 'true');
      announce(root, row, message(root, 'invalid'), true);
      return;
    }
    input.removeAttribute('aria-invalid');
    var roots = Array.from(document.querySelectorAll('[data-rp-cart]'));
    if (busy || roots.some(function (cart) { return cart.actionBusy; })) {
      input.value = confirmed;
      announce(root, row, message(root, 'busy'), false);
      return;
    }
    if (root.hasAttribute('data-rp-needs-refresh')) {
      input.value = confirmed;
      announce(root, row, message(root, 'refresh-error'), true);
      return;
    }
    if (quantity === confirmed) return;

    busy = true;
    var controls = [];
    var scroll = { x: window.scrollX, y: window.scrollY };
    var drawerBody = root.querySelector('.Drawer__Body');
    var drawerScroll = drawerBody ? drawerBody.scrollTop : 0;
    roots.forEach(function (cart) {
      cart.actionBusy = true;
      cart.setAttribute('aria-busy', 'true');
      cart.setAttribute('data-rp-quantity-busy', '');
      cart.querySelectorAll('button, [data-rp-quantity]').forEach(function (control) {
        controls.push({ element: control, disabled: control.disabled });
        if (!control.matches('[data-tg-dismiss], .ButtonClose')) control.disabled = true;
      });
    });
    input.value = quantity;
    announce(root, row, message(root, 'updating'), false);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var rejected = false;
    var saved = false;
    var focusMoved = false;
    var onFocus = function (event) {
      if (event.target !== trigger && event.target !== input && event.target !== document.body) focusMoved = true;
    };
    document.addEventListener('focusin', onFocus);

    try {
      var response = await fetch(window.routes.cartChangeUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!response.ok) {
        rejected = response.status === 422 || response.status === 400;
        throw new Error('Cart quantity request rejected');
      }
      var cart = await response.json();
      saved = true;
      root.itemCount = cart.item_count;
      var updated = cart.items.find(function (item) { return item.key === key; });
      await root._rerenderCart(false);
      var freshRow = rowFor(root, key);
      announce(root, freshRow, message(root, removing ? 'removed' : updated && updated.quantity !== quantity ? 'adjusted' : 'updated'), false);
      var freshInput = freshRow && freshRow.querySelector('[data-rp-quantity]');
      if (!focusMoved) {
        var focusTarget = freshInput;
        if (freshRow && step) focusTarget = freshRow.querySelector('[data-rp-step="' + step + '"]');
        if (!focusTarget || focusTarget.disabled) focusTarget = freshInput || root.querySelector('[data-rp-quantity], .ButtonClose');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        if (wasInput && freshInput) freshInput.select();
      }
      if (drawerBody) drawerBody.scrollTop = drawerScroll;
      if (root.tagName === 'SECTION-CART') window.scrollTo(scroll.x, scroll.y);
      roots.filter(function (other) { return other !== root; }).forEach(function (other) {
        if (typeof other._rerenderCart === 'function') other._rerenderCart(false).catch(function () {});
      });
    } catch (error) {
      input.value = confirmed;
      if (!rejected || saved) {
        roots.forEach(function (cart) { cart.setAttribute('data-rp-needs-refresh', ''); });
      }
      announce(root, rowFor(root, key) || row, message(root, rejected && !saved ? 'error' : 'refresh-error'), true);
    } finally {
      document.removeEventListener('focusin', onFocus);
      controls.forEach(function (state) { if (state.element.isConnected) state.element.disabled = state.disabled; });
      roots.forEach(function (cart) {
        cart.actionBusy = false;
        cart.removeAttribute('aria-busy');
        cart.removeAttribute('data-rp-quantity-busy');
        if (cart.hasAttribute('data-rp-needs-refresh')) {
          cart.querySelectorAll('[name="checkout"]').forEach(function (button) { button.disabled = true; });
        }
      });
      busy = false;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest(mutationSelector);
    if (!target) return;
    var root = target.closest('[data-rp-cart]');
    if (!root) return;
    if (busy || root.hasAttribute('data-rp-needs-refresh')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!target.matches('[data-rp-step], [data-rp-remove]')) return;
    var row = target.closest('[data-rp-line]');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var input = row.querySelector('[data-rp-quantity]');
    var base = Number(input.value);
    if (!Number.isSafeInteger(base) || base < 1) base = Number(row.getAttribute('data-rp-confirmed'));
    update(root, row, target.hasAttribute('data-rp-remove') ? 0 : Math.max(1, base + Number(target.getAttribute('data-rp-step'))), target);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-rp-quantity]')) return;
    var root = input.closest('[data-rp-cart]');
    if (!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    update(root, input.closest('[data-rp-line]'), Number(input.value), input);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-rp-quantity]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.target.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  document.addEventListener('submit', function (event) {
    var root = event.target.closest('[data-rp-cart]');
    if (root && (busy || root.actionBusy || root.hasAttribute('data-rp-needs-refresh'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
